import {array, is, number} from 'valibot';

import {useLocalSplit} from '@/modules/common/hooks/useLocalSplit';

const sponsoredHotelPlacementsSchema = array(number());

export const useSponsoredAdsSplit = () => {
  const {config, ready, treatment} = useLocalSplit<'off' | 'on' | 'default'>(
    'FFP_4895_find_sponsored_hotel_platform_195'
  );

  return {
    sponsoredAdEnabled: ready && treatment === 'on',
    sponsoredAdPositions: is(sponsoredHotelPlacementsSchema, config)
      ? config
      : undefined,
  };
};
